module.exports = __webpack_public_path__ + "5927ec25e41ca39a91aff3328c7d1791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/072.jpg
// module id = 15
// module chunks = 0